import React, { useState, useEffect } from "react";
import { Button, TextField ,CircularProgress, Fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert, AlertTitle } from "@material-ui/lab";
// data
import { CreateTransaction } from "./createTransactions-api";
//auth
import auth from "../../../auth/auth-helper";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200,
    },
  },
}));

export default function Transactions() {
  var classes = useStyles();
  var [msg, setMsg] = useState(null);
  var [isLoading, setIsLoading] = useState(false);
  const [fromAccount_no, setFromAccount_no] = useState([]);
  const [toAccount_no, setToAccount_no] = useState([]);
  const [amount, setAmount] = useState([]);
  const [detail, setDetail] = useState([]);

  const clickSubmit = () => {
    setIsLoading(true)
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    const transaction = {
      fromAccount_no:  fromAccount_no,
      toAccount_no: toAccount_no,
      amount:amount,
      detail:detail,
    };

    CreateTransaction(signal, credentials, transaction).then((res) => {
      console.log(transaction)
      if (res.status === 200) {
        console.log("token here ....................." + credentials);
        // console.log(res.status);
        setMsg(res.response);
        console.log(res);
        //console.log(res.statusCode);
       
      } else {
        setMsg(res.response);
      }
      setIsLoading(false)
    });

  }

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <div
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TextField
          label="From (Account No)"
          value={fromAccount_no}
          onChange={(e) => setFromAccount_no(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="To (Account No)"
          value={toAccount_no}
          onChange={(e) => setToAccount_no(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <TextField
          label="Detail"
          value={detail}
          onChange={(e) => setDetail(e.target.value)}
          id="outlined-size-small"
          defaultValue="Small"
          variant="outlined"
          size="small"
        />
        <br></br>
        <div className={classes.creatingButtonContainer}>
          {isLoading ? (
            <CircularProgress size={26} />
          ) : (
            <Button
              disabled={
                toAccount_no.length === 0 ||
                fromAccount_no.length === 0 ||
                amount.length === 0 ||
                detail.length === 0
              }
              variant="contained"
              color="primary"
              onClick={clickSubmit}
            >
              Continue
            </Button>
          )}
        </div>
        <Fade in={msg}>
          <Alert severity="info">
            <AlertTitle>Status</AlertTitle>
            {msg} <strong>check it out!</strong>
          </Alert>
        </Fade>
      </div>
    </form>
  );
}
